import { cn } from '@/lib/utils'

const inputClass =
  'w-full rounded-md border border-[var(--border)] bg-[var(--card)] px-3 text-sm text-[var(--foreground)] placeholder:text-[#a8a29e] focus:border-[var(--accent)] focus:outline-none focus:ring-1 focus:ring-[var(--accent)]/15 transition-colors'

function Input({
  className,
  ...props
}: React.ComponentProps<'input'>) {
  return (
    <input
      className={cn(inputClass, 'h-11', className)}
      {...props}
    />
  )
}

function Textarea({
  className,
  ...props
}: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(inputClass, 'py-2.5 resize-none', className)}
      {...props}
    />
  )
}

export { Input, Textarea, inputClass }
